/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Preview_Download_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to download: {error}" |
*
* @param {Image_Export_Preview_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_download_failed = /** @type {((inputs: Image_Export_Preview_Download_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Download_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du telechargement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Download fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile scaricare: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la descarga: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`下载失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ダウンロードに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`डाउनलोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao baixar: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to download: ${i?.error}`)
});